import React, { useEffect, useState } from 'react';
import GridInputs from '../../components/common/inputs/GridInputs';
import MenuItem from '@mui/material/MenuItem';
import { IData } from './Interface';
import axios from 'axios';
import { SubmitButton } from '../../components/common/button/CustomButtons';
import SelectGridMui from '../../components/common/selectscustom/SelectGridMui';
import useConfirm from '../../components/common/useConfirm';
import moment from 'moment';
import DateGridMui from '../../components/common/dateCustom/DateGridMui';
import AutocompleteGridmui from '../../components/common/autocomplete/AutocompleteGridmui';

const Create = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [moduleData, setModuleData] = useState<IData>({
    employee_name: '',
    employee_id: '',
    skill_level: '',
    payment_type: '',
    category: '',
    description: '',
    designation: '',
    leaves: '',
    data_of_joining: null,
    department_id: null,
  });

  const [render, setRender] = useState(false);
  const [department, setDepartment] = useState([]);
  const [autoCompleteDepartment, setAutocompleteDepartment] = useState('');
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Employee' : 'Create Employee'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`,
  );

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/employee/${id}`)
        .then((res) => {
          setModuleData(res.data);
          setAutocompleteDepartment(res.data.department_id);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleModulData(e: React.ChangeEvent<HTMLInputElement>) {
    setModuleData((prev: any) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  }

  const handleSumbit = async () => {
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/employee/${id}`, moduleData)
        .then((res) => {
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post('/api/employee', moduleData)
        .then((res) => {
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    }
  };

  useEffect(() => {
    axios
      .get(`/api/department`)
      .then((res) => setDepartment(res.data.results))
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <GridInputs
        id={'employee_name'}
        name={'employee_name'}
        html_for={'employee_name'}
        label_name={'Employee Name:'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.employee_name}
        onChange={handleModulData}
      />
      <GridInputs
        id={'employee_id'}
        name={'employee_id'}
        html_for={'employee_id'}
        label_name={'Eployee ID'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.employee_id}
        onChange={handleModulData}
      />
      <GridInputs
        id={'description'}
        name={'description'}
        html_for={'description'}
        label_name={'Description'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.description}
        onChange={handleModulData}
      />

      <AutocompleteGridmui
        label={'Department Name'}
        id={'department_name'}
        option_name={'department_name'}
        value={autoCompleteDepartment}
        arrayofObj={department}
        onChange={(e, value) => {
          moduleData.department_id = value?._id;
          setAutocompleteDepartment(value);
          setRender((prev) => !prev);
        }}
      />

      <DateGridMui
        lable="Date of Joining"
        onChange={(date: any) => {
          moduleData.data_of_joining = date;
          setRender((prev) => !prev);
        }}
        value={moment(moduleData.data_of_joining) || null}
      />

      <SelectGridMui
        name="skill_level"
        value={moduleData?.skill_level || ''}
        lable={'Skill Level'}
        onChange={(e: any) => handleModulData(e)}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem value="Level 1">Level 1</MenuItem>
        <MenuItem value="Level 2">Level 2</MenuItem>
        <MenuItem value="Level 3">Level 3</MenuItem>
        <MenuItem value="Level 4">Level 4</MenuItem>
      </SelectGridMui>

      <SelectGridMui
        name="payment_type"
        value={moduleData?.payment_type || ''}
        lable={'Payment Type'}
        onChange={(e: any) => handleModulData(e)}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem value="co_roll">Co. Roll</MenuItem>
        <MenuItem value="regular">Regular</MenuItem>
      </SelectGridMui>

      <SelectGridMui
        name="category"
        value={moduleData?.category || ''}
        lable={'Category'}
        onChange={(e: any) => handleModulData(e)}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem value="staff">Staff</MenuItem>
        <MenuItem value="contractual">Contractual</MenuItem>
        <MenuItem value="operator">Operator</MenuItem>
      </SelectGridMui>

      <GridInputs
        id={'designation'}
        name={'designation'}
        html_for={'designation'}
        label_name={'Designation'}
        input_type={'text'}
        focusType={'onblur'}
        value={moduleData?.designation}
        onChange={handleModulData}
        last_child={2}
      />

      <SelectGridMui
        name="leaves"
        value={moduleData?.leaves || ''}
        lable={'Allowed For Leaves'}
        onChange={(e: any) => handleModulData(e)}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem value="yes">Yes</MenuItem>
        <MenuItem value="no">No</MenuItem>
      </SelectGridMui>

      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default Create;
